// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import baoRouter from "./../services/bao-router";
import BaseReportCenterModule from "./../factories/base-report-center-module";
import GuidFactory from "./../factories/guid";
import "./../bindings/bao-template";
import "./../bindings/bao-pager";
function ReportCenterViewModel(tabPage) {
    var self = this;
    self.Bao = Bao;
    self.TabPage = tabPage;
    self.ReportCenterModule = ko.observable();
    self.TemplateName = ko.observable();
    self.Initialized = ko.observable(false);
    self.AllReports = ko.observableArray();
    self.FormReportId = ko.observable();
    if (!self.TabPage.ObjectId()) {
        self.TabPage.ObjectId(GuidFactory());
    }
    self.FormReportId.subscribe(function (formReportId) {
        if (self.Initialized() == true && formReportId != "00000000-0000-0000-0000-000000000000") {
            var param = baoRouter.getRouteValue("param", tabPage);
            baoRouter.setHash("reportcenter/" + self.TabPage.ObjectId() + "/" + formReportId + (param ? "/" + param : ""));
            $.each(self.AllReports(), function (index, row) {
                if (row.Options != null) {
                    $.each(row.Options, function (index, report) {
                        if (report.FormReportId == formReportId) {
                            self.ChangeTemplate(ko.unwrap(report.WebUrl) + (param ? "/" + param : ""), formReportId);
                        }
                    });
                }
            });
        }
    });
    self.ChangeTemplate = function (url, id) {
        tabPage.IsLoading(true);
        Bao.get(url, function (template) {
            var templateName = "reportcenter" + id;
            Bao.Templates[templateName] = template;
            tabPage.IsLoading(false);
            self.TemplateName(templateName);
        });
    };
    self.SaveFilter = function (filter, sorting, topnumber) {
        return Bao.post("ReportCenter/SaveReportFilters", JSON.stringify({
            reportCenterReportId: self.FormReportId(),
            filter: filter,
            sorting: sorting,
            topNumber: topnumber
        }));
    };
    self.GetFilter = function () {
        return Bao.post("ReportCenter/GetReportFilters", JSON.stringify({
            reportCenterReportId: self.FormReportId()
        }));
    };
    self.GetFilterHashObject = function (properties, viewModel, keyAliases) {
        var filterObject = [];
        if (typeof keyAliases === "undefined" || keyAliases === null || properties.length !== keyAliases.length) {
            keyAliases = properties;
        }
        for (var i in properties) {
            if (typeof viewModel[properties[i]] !== "undefined") {
                filterObject.push({
                    Key: keyAliases[i],
                    Value: ko.unwrap(viewModel[properties[i]])
                });
            }
        }
        return filterObject;
    };
    self.DownloadReport = function (reportName, data) {
        tabPage.IsLoading(true);
        Bao.post("ReportCenter/GetDownload" + reportName, JSON.stringify(data), function (result) {
            tabPage.IsLoading(false);
            if (result.Result == true) {
                baoRouter.setHash("document/" + result.Message);
            }
            else {
                new BaoDialogViewModel(Bao.Session.GetApplicationName(), result.Message, "info");
            }
        });
    };
    self.init = function () {
        var title = Bao.Session.GetMessage("ReportCenter");
        self.TabPage.Title(title());
        title.subscribe(function (value) {
            self.TabPage.Title(title());
        });
    };
    self.loaded = function () {
        tabPage.TabSelected = self.TabSelected;
        var key = baoRouter.getRouteValue("key", self.TabPage);
        return;
    };
    self.loadReports = function () {
        self.TabPage.IsLoading(true);
        return Bao.post("ReportCenter/GetReports", JSON.stringify({})).then(function (result) {
            self.AllReports(result);
            self.FormReportId("00000000-0000-0000-0000-000000000000");
            self.Initialized(true);
            self.TabPage.IsLoading(false);
        });
    };
    self.init = function () {
        tabPage.IsLoading(true);
        return self.loadReports();
    };
    self.loaded = function () {
        var def = $.Deferred();
        tabPage.Title("Reportcenter");
        tabPage.IsLoading(false);
        def.resolve();
        var reportid = baoRouter.getRouteValue("reportid", tabPage);
        if (reportid != undefined) {
            self.FormReportId(reportid);
        }
        return def.promise();
    };
}
export default ReportCenterViewModel;